import React from "react";

import {
  UpcomingStarts as UpcomingStartsType,
} from "./dashboardType"

interface Props {
  data: UpcomingStartsType;
}

const UpcomingStarts: React.FC<Props> = ({
  data,
}) => {
  const items = [
    ["Tomorrow", data.Tomorrow],
    [
      "Next 3 Days",
      data.Next_3_Days,
    ],
    [
      "Next 7 Days",
      data.Next_7_Days,
    ],
    [
      "Next 15 Days",
      data.Next_15_Days,
    ],
    [
      "Next 30 Days",
      data.Next_30_Days,
    ],
  ];

  return (
    <section className="rounded-xl border bg-white p-5 shadow-sm">
      <h2 className="mb-4 text-lg font-semibold">
        Upcoming Starts
      </h2>

      <div className="grid grid-cols-2 gap-4 md:grid-cols-5">
        {items.map(
          ([label, value]) => (
            <div
              key={String(label)}
              className="rounded-lg bg-gray-50 p-4"
            >
              <p className="text-sm text-gray-500">
                {label}
              </p>

              <p className="mt-1 text-xl font-bold">
                {value}
              </p>
            </div>
          )
        )}
      </div>
    </section>
  );
};

export default UpcomingStarts;